export const BUCKETS = { MAGNETSTSBUILDARCHIVES: 'magnet-sts-build-archives' };

export const STATES = {
  PENDING: 0,
  RUNNING: 16,
  SHUTTINGDOWN: 32,
  TERMINATED: 48,
  STOPPING: 64,
  STOPPED: 80
};

export const DEFAULTREGION = 'All Regions';

export const DEFAULTACCOUNT = 'All Accounts';

export const PERIODICITIES = {
  DAILY: 'Daily',
  MONTHLY: 'Monthly'
};

export const MANDATORYTAGS =
{
  NAME: 'name',
  OWNER: 'owner',
  BESTBEFORE: 'bestbefore'
};


// WEBPACK FOOTER //
// src/helpers/aws.js